import Vue from 'vue';

const success = (context, response) => {
  if (response && response.status === 200) {
    localStorage.removeItem('confirmed');
    localStorage.setItem('isConfirmed', 1);
    Vue.router.push({
      name: 'calendar.type',
      params: { type: 'annual' },
    });
  }
};

const failed = (context, error) => {
  if (error.response) {
    Vue.router.push({
      name: 'calendar.type',
      params: { type: 'annual' },
    });
  }
  context.showToasterError(error);
};

export default (context, data) => Vue.$http.post('/user/confirm', data).then((response) => {
  if (response && response.status === 200) {
    success(context, response);
  }
})
  .catch((error) => {
    if (error) {
      failed(context, error);
    }
  });



// WEBPACK FOOTER //
// ./src/app/services/account/confirmAccount.js